// store.js
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import CustomerSlice from './Reducers/Customer/CustomerSlice';
import ProjectSlice from './Reducers/Project/ProjectSlice';
import USerSlice from './Reducers/User/USerSlice';
import UserImageSlice from './Reducers/User/UserImage';

// Configuration for redux-persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['customer', 'project', 'user','userImage'], // Names of slices to persist
};

// Combine slices into root reducer using combineReducers
const rootReducer = combineReducers({
  customer: CustomerSlice,
  project: ProjectSlice,
  user: USerSlice,
  userImage:UserImageSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

export default store;
